export const LoadingMainPage = () => {
  const SKELETON_CARDS = ['card-1', 'card-2', 'card-3', 'card-4'];
  const SKELETON_ROWS = ['row-1', 'row-2', 'row-3'];
  return (
    <div
      className="bg-background text-foreground min-h-screen flex flex-col items-center justify-start"
      aria-busy="true"
      aria-live="polite"
      role="status"
    >
      <div className="flex flex-col items-center justify-center py-16 px-8 w-full">
        <div className="h-12 w-2/3 max-w-2xl bg-gray-700/40 rounded animate-pulse mb-4" />
        <div className="h-6 w-1/2 bg-gray-700/30 rounded animate-pulse mb-6" />
      </div>
      <main className="container mx-auto px-8 pb-16 w-full">
        <div className="mb-6">
          <div className="h-6 w-40 bg-gray-700/30 rounded animate-pulse mb-2" />
          <div className="h-8 w-full bg-gray-700/20 rounded animate-pulse mb-4" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mb-8">
          {SKELETON_CARDS.map((id) => (
            <div key={id} className="flex flex-col items-center">
              <div className="h-64 w-full bg-gray-700/30 rounded-lg animate-pulse mb-2" />
              <div className="h-4 w-1/2 bg-gray-700/20 rounded animate-pulse" />
            </div>
          ))}
        </div>
        <div className="mb-4">
          <div className="h-6 w-32 bg-gray-700/30 rounded animate-pulse mb-2" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {SKELETON_ROWS.map((id) => (
            <div
              key={id}
              className="h-12 w-full bg-gray-700/20 rounded animate-pulse"
            />
          ))}
        </div>
      </main>
      <span className="sr-only">Loading...</span>
    </div>
  );
};
